import { render } from "./DashboardTopNav.vue?vue&type=template&id=5d559fe2&scoped=true"
import script from "./DashboardTopNav.vue?vue&type=script&lang=js"
export * from "./DashboardTopNav.vue?vue&type=script&lang=js"

import "./DashboardTopNav.vue?vue&type=style&index=0&id=5d559fe2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d559fe2"]])

export default __exports__